import React from "react";
import "./KeyboardSettings.css";

const KeyMapping = {
  MainCommands: {
    Forward: "w",
    Backward: "s",
    Left: "a",
    Right: "d",
  },
  SpeedCommands: {
    IncreaseSpeed: "r",
    DecreaseSpeed: "f",
    IncreaseRpm: "Shift",
    DecreaseRpm: "Control",
  },
  OtherCommands: {
    Brake: " ", // Space
    StartEngine: "g",
    Headlight: "l",
    Tool: "t",
  },
  TranslationCommands: {
    TranslationRight: "ArrowRight",
    TranslationLeft: "ArrowLeft",
    ArmUp: "ArrowUp",
    ArmDown: "ArrowDown",
  },
  AuxCommands: {
    CoverFlailUp: "u",
    CoverFlailDown: "j",
    HydraulicAuxUp: "z",
    HydraulicAuxDown: "h",
    ElectricAux: "x",
    Enlargement: "n",
    Shrinking: "m",
    NeutralFlotting: "b",
  },
  StateCommands: {
    MaintenanceState: "1",
    ParkingState: "2",
    DockingState: "3",
    DrivingState: "4",
    AutonomousState: "5",
  },
  MiscCommands: {
    Ignition: "p",
    Emergency: "Enter",
  },
};

const renderCommands = (commands) =>
  commands.map(({ key, action }) => (
    <div key={key} className="setting">
      <p className="key">{key === " " ? "Space" : camelCaseToNormalCase(key)}</p>
      <p className="action">{camelCaseToNormalCase(action)}</p>
    </div>
  ));

function camelCaseToNormalCase(text) {
  const result = text
    .replace(/([A-Z])/g, " $1")
    .trim()
    .toLowerCase();
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult;
}

export default function KeyboardSettings({ keymapping }) {
  return (
    <div className="settings-board">
      <div className="main-commands">
        <h2>Main commands</h2>
        <div className="main">
          <div className="move">
            {renderCommands(
              Object.entries(KeyMapping.MainCommands).map(([action, key]) => ({ action, key }))
            )}
          </div>
          <div className="speed">
            {renderCommands(
              Object.entries(KeyMapping.SpeedCommands).map(([action, key]) => ({ action, key }))
            )}
          </div>
        </div>
      </div>
      <div className="states">
        <h2>States</h2>
        <div className="content">
          {renderCommands(
            Object.entries(KeyMapping.StateCommands).map(([action, key]) => ({ action, key }))
          )}
          {renderCommands(
            Object.entries(KeyMapping.MiscCommands).map(([action, key]) => ({ action, key }))
          )}
        </div>
      </div>
      <div className="more-actions">
        <h2>More actions</h2>
        <div className="content">
          {renderCommands(
            Object.entries(KeyMapping.AuxCommands).map(([action, key]) => ({ action, key }))
          )}
        </div>
      </div>
      <div className="translation">
        <h2>Translation</h2>
        <div className="content">
          <div className="setting">
            <p className="key">⇨</p>
            <p className="action">Translation Right</p>
          </div>
          <div className="setting">
            <p className="key">⇦</p>
            <p className="action">Translation Left</p>
          </div>
          <div className="setting">
            <p className="key">⇧</p>
            <p className="action">Arm Up</p>
          </div>
          <div className="setting">
            <p className="key">⇩</p>
            <p className="action">Arm Down</p>
          </div>
        </div>
      </div>
      <div className="engine">
        <h2>Engine</h2>
        <div className="content">
          {renderCommands(
            Object.entries(KeyMapping.OtherCommands).map(([action, key]) => ({ action, key }))
          )}
        </div>
      </div>
    </div>
  );
}
